import { merge } from 'lodash'
import { IAccountSeller, ISeller, ISellerHeader } from 'containers/App/appLayoutTypes'

export const processLeads = (leadsResponseData: ISeller[]) =>
  leadsResponseData.map(item => {
    return {
      ...item,
      id: item.id,
      cnpj: item.company?.cnpj || '',
      tenantId: item.seller_id || '',
      tradingName: item.company?.trading_name || '',
      legalName: item.company?.name || '',
      status: item.status_lead,
      actions: item.actions,
      isOwner: item.is_owner || false,
      services: item.services || null,
    }
  })

export const processAccountSeller = (accountDetails: IAccountSeller) =>
  accountDetails.sellers.map((item: ISellerHeader) => {
    return {
      ...item,
      profile: item.profile,
      isCurrent: item.current,
    }
  })

export const mergeArrayAccountByLeads = ({
  sellers,
  sellersAccount,
}: {
  sellers: ISellerHeader[]
  sellersAccount: ISellerHeader[]
}) => {
  const mergedArray: ISellerHeader[] = []

  if (sellersAccount !== undefined) {
    sellers.forEach(lead => {
      const foundLeadSellerAccount = sellersAccount.find(
        sellerAccount => sellerAccount.tenantId === lead.tenantId
      )

      /* istanbul ignore else */
      if (!foundLeadSellerAccount) {
        mergedArray.push(lead)
      } else {
        const mergeLeadAndSellerAccount = merge(foundLeadSellerAccount, lead)
        mergedArray.push(mergeLeadAndSellerAccount)
      }
    })
  }

  return mergedArray
}

type TVerifySellerCallback = (seller: ISellerHeader) => void

export const verifySellerIsDifferent = (
  concatenatedArraySellerHeader: ISellerHeader[],
  callback: TVerifySellerCallback
) => {
  if (!concatenatedArraySellerHeader.length) {
    return
  }

  const leadId = sessionStorage.getItem('maas-leadId')

  const sellerWithLeadId = concatenatedArraySellerHeader.find(({ id }) => id === leadId)

  const defaultSeller =
    concatenatedArraySellerHeader.find(({ isCurrent }) => isCurrent) ||
    concatenatedArraySellerHeader[0]

  const tenantIdSeller =
    sellerWithLeadId?.tenantId || sessionStorage.getItem('maas-tenantId') || defaultSeller.tenantId

  const matchedSeller = concatenatedArraySellerHeader.find(
    ({ tenantId }) => tenantId === tenantIdSeller
  )

  if (matchedSeller) {
    callback?.(matchedSeller)
    sessionStorage.setItem('maas-tenantId', matchedSeller.tenantId || '')
    sessionStorage.removeItem('maas-leadId')
  }
}
